export const registerPropertyServices = async (formData) => {
  // Destructure the data from formData
  const {
    strataPlan,
    serviceName,
    serviceProvider,
    providerEmail,
    providerPhone,
    contract,
    contractDate,
  } = formData;

  try {
    const response = await fetch(
      "https://model-seasnail-56.hasura.app/v1/graphql",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-hasura-admin-secret":
            "0NQxxnVCzWSNpCars6Bp5Jtlfr04A27EruT9EVRpg0iOfQkpUtXG6Fg5xCPt045G",
        },
        body: JSON.stringify({
          query: `
          mutation RegisterPropertyServices($strataPlan: String!, $serviceName: String!, $serviceProvider: String!, $providerEmail: String!, $providerPhone: String!, $contract: Boolean!, $contractDate: date) {
            insert_property_services(objects: {serv_strata_plan_no: $strataPlan, service_name: $serviceName, service_provider: $serviceProvider, provider_email: $providerEmail, provider_phone_no: $providerPhone, contract: $contract, contract_renewal_date: $contractDate}) {
              returning {
                id
              }
            }
          }
        `,
          variables: {
            strataPlan,
            serviceName,
            serviceProvider,
            providerEmail,
            providerPhone,
            contract,
            contractDate,
          },
        }),
      }
    );

    const data = await response.json();

    if (data.errors) {
      console.error(data.errors);
      const errorMessage = data.errors
        .map(
          (error) =>
            `Message: ${error.message}, Code: ${error.extensions?.code}`
        )
        .join("\n");
      alert(
        `Failed to register property service. Error details:\n${errorMessage}`
      );
      return null;
    } else {
      alert(
        `Successfully registered property service ${serviceName} for ${strataPlan}`
      );
      return data.data.insert_property_services.returning[0].id; // Return the id of the newly inserted record
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};
